export default class CmsFeatures {

    constructor() {
        this.activateSwiper();
        this.addEvents();
        this.handleResize();
        this.tabChange = false;
    }

    addEvents() {
        const swiperInstance = document.querySelector('.cms-features .cms-features__content')?.swiper;
        const funcThis = this;
        if(swiperInstance) {
            swiperInstance.off('slideChange').on('slideChange', function (swiper) {
                const swiperTabInstance = document.querySelector('.cms-features .cms-features__tabs')?.swiper;
                let sliderRealIndex = swiper.realIndex
                const activeTab = $(`.cms-features__tabs .cms-features__tab[data-index="${sliderRealIndex}"]`);
                const activeTabIndex = activeTab.index();

                $('.cms-features__tabs .cms-features__tab.active').removeClass('active');
                activeTab.addClass('active')

                if(!funcThis.tabChange){
                    if(swiper?.swipeDirection == 'next'){
                        swiperTabInstance.slideNext()
                    } else if(swiper?.swipeDirection == 'prev'){
                        swiperTabInstance.slidePrev()
                    } else {
                        swiperTabInstance.slideTo(activeTabIndex, 500)
                    }
                }

                funcThis.tabChange = false;
            })

            $('.cms-features__tabs .cms-features__tab').off('click').on('click', function () {
                let tabIndex = $(this).data('index');
                let slideIndex = $(`.cms-features__content .swiper-slide:not(.swiper-slide-duplicate)[data-swiper-slide-index="${tabIndex}"]`)?.index();
                swiperInstance.slideTo(slideIndex,500);
            })
        }

    }

    activateSwiper() {
        const funcThis = this;

        let lastActiveIndex = 0;
        const swiperTabInstance = new Swiper('.cms-features__tabs.swiper-container', {
            slidesPerView: 8,
            spaceBetween: 10,
            speed: 500,
            loop: false,
            pagination: false,
            centeredSlides: false,
            navigation: {
                nextEl: '.cms-features__nav--right',
                prevEl: '.cms-features__nav--left',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    loop: true,
                    navigation: {
                        nextEl: '.cms-features__nav--right',
                        prevEl: '.cms-features__nav--left',
                    },
                },
                768: {
                    slidesPerView: 3,
                    loop: true,
                },
                1024: {
                    slidesPerView: 'auto',
                    loop: false,
                },
            },
            on: {
                slideChange: (swiper) => {
                    const swiperInstance = document.querySelector('.cms-features .cms-features__content')?.swiper;
                    const contentActiveIndex = swiper.activeIndex;
                    const activeSlide = swiper.slides[contentActiveIndex];
                    let tabIndex = $(activeSlide).data('index');
                    let slideIndex = $(`.cms-features__content .swiper-slide:not(.swiper-slide-duplicate)[data-swiper-slide-index="${tabIndex}"]`)?.index();
                    funcThis.tabChange = true;
                    swiperInstance.slideTo(slideIndex,500);
                },
            },
        });
    }

    handleResize() {
        let tablet_mobile = false;
        let desktop = false;
        $(window).on('resize', () => {
            if ($(window).width() < 1024 && !tablet_mobile) {
                tablet_mobile = true;
                desktop = false;
                $('.cms-features__tabs .swiper-wrapper.disabled-transform').removeClass('disabled-transform')
                this.activateSwiper();
                this.addEvents();
            }
            else if($(window).width() >= 1024 && !desktop){
                tablet_mobile = false;
                desktop = true;
                setTimeout(() => {
                    $('.cms-features__tabs .swiper-slide-duplicate').each(function () {
                        $(this).remove();
                    });
                    $('.cms-features__tabs .swiper-wrapper').addClass('disabled-transform')
                    this.activateSwiper();
                    this.addEvents();
                }, 500);

            }
        });
    }

}